import $ from 'jquery';
import events from '../shared/events';
import {tesOrderControlInteraction} from './events';
import waitForElement from '../../../dom/waitforelement';
import wishList from '../wishlist';
import zipCode from '../../shared/zipcode';

export default function belowTheFold(productClassViewModel, observe) {
    const $video = document.querySelector('.productClassVideo'),
        $bloomReach = document.getElementById('br-widgets'),
        $recentlyViewed = document.getElementById('recently-viewed-container'),
        $contentSections = document.querySelector('.content-sections');

    if ($video) {
        observe($video, () => {
            import('./videosection').then(({default: videoSection}) => videoSection.init());
        });
    }

    if ($bloomReach) {
        observe($bloomReach, () => {
            import('../../shared/bloomreach').then(({default: bloomReach}) =>
                bloomReach.init($bloomReach.querySelector('.BRRelatedProducts'), '.br-sf-widget')
            );
        });
    }

    if ($contentSections) {
        observe($contentSections, () => {
            import('./contentmanager').then(({default: contentManager}) => contentManager.init($contentSections));
        });
    }

    if (productClassViewModel.hasCustomization) {
        import('./customizer').then(({default: customizer}) => customizer.init(productClassViewModel));
    }

    waitForElement('.reviewStars .bv_numReviews_component_container', () => {
        import('../shared/reviews').then(({default: reviews}) => reviews.updateBVData());
    });

    wishList.init();

    if ($recentlyViewed) {
        observe($recentlyViewed, () => {
            import('../shared/recentlyviewed').then(({default: recentlyViewed}) =>
                recentlyViewed.init(document.getElementById('divRecentlyViewedProducts'))
            );
        });
    }

    $(document)
        .on('.asTip .tooltipTrigger', 'click', function() {
            tesOrderControlInteraction('AutoShip details click');
        })
        .on('click', '#productManufacturer a', function() {
            events._gaEvent('Product manufacturer click', window.location.href, 'Product Manufacturer');
        });

    waitForElement('#productClassCon [data-bv-show="rating_summary"] svg', function(elements) {
        if (elements) {
            [].slice.call(elements).forEach(function(element) {
                element.style.removeProperty('height');
                element.style.removeProperty('width');
            });
        }
    });

    $('#productClassCon').on('click', '.preferredZipCode', function(e) {
        e.preventDefault();
        zipCode._getPreferredZipCodeView();
    });
}
